import { render, staticRenderFns } from "./abnormalReason.vue?vue&type=template&id=7b29d29f&scoped=true"
import script from "./abnormalReason.vue?vue&type=script&lang=js"
export * from "./abnormalReason.vue?vue&type=script&lang=js"
import style0 from "./abnormalReason.vue?vue&type=style&index=0&id=7b29d29f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b29d29f",
  null
  
)

export default component.exports